import React from 'react'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import './index.css'

const FormInputPhone = ({
  Form,
  handlePhoneNumberChange,
  userCountryCode,
  userContactNumber,
  label,
  name,
  inputStyle = {},
}) => {
  return (
    <div className="__formInputWrapper">
      <Form.Item className="v2FormInput" label={<React.Fragment>{label}</React.Fragment>}>
        <PhoneInput
          Form={Form}
          inputStyle={inputStyle}
          dropdownClass="contactNumberCode"
          inputClass="contactNumberInput"
          buttonClass="contactNumberButton"
          enableSearch="true"
          country={userCountryCode}
          countryCodeEditable={false}
          name={name}
          value={userContactNumber}
          rules={[
            {
              message: 'Please input your phone number',
            },
          ]}
          onChange={(phone, data) => handlePhoneNumberChange(phone, data)}
        />
      </Form.Item>
    </div>
  )
}

export default FormInputPhone
